package fr.manyverse.app.presentation.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import fr.manyverse.app.domain.model.UniverseConfig

/**
 * Wraps [content] in a [MaterialTheme] coloured for the given universe [config]. Uses the
 * universe's custom seed colour when present (generated via MaterialKolor), otherwise the
 * built-in palette. The dark/light variant is decided by the caller (so it can keep
 * following the user's app-wide theme preference).
 */
@Composable
fun UniverseTheme(
    config: UniverseConfig,
    isDark: Boolean,
    content: @Composable () -> Unit
) {
    MaterialTheme(
        colorScheme = rememberUniverseColorScheme(config, isDark),
        typography = manyverseTypography(),
        content = content
    )
}
